import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { marketingUrl } from '../lib/marketingUrls';
import { Code, FileText } from 'lucide-react';

const integrationContactHref = marketingUrl('/contact?sourcePage=integration');

export default function Integration() {
  return (
    <section className="space-y-4 py-4">
        <h1>Integration</h1>
        <p className="text-muted-foreground">
          mySign.az provides powerful integration capabilities that allow you to seamlessly connect our digital signature platform with your existing systems and workflows.
        </p>
        <p className="text-muted-foreground">
          Whether you're using CRM systems, document management platforms, or custom business applications, our API enables you to automate document signing processes and integrate digital signatures directly into your workflow.
        </p>

        <h2 className="pt-4 text-xl font-semibold">Integration Possibilities</h2>
        <p className="text-muted-foreground">Our platform supports integration with various systems including:</p>
        <ul className="list-inside list-disc space-y-1 text-muted-foreground">
          <li>Customer Relationship Management (CRM) systems</li>
          <li>Document Management Systems (DMS)</li>
          <li>Enterprise Resource Planning (ERP) systems</li>
          <li>Workflow automation platforms</li>
          <li>Custom business applications</li>
          <li>Cloud storage services</li>
        </ul>

        <h2 className="pt-4 text-xl font-semibold">API Documentation</h2>
        <p className="text-muted-foreground">
          Access our comprehensive API documentation to get started with integrating mySign.az into your systems. The documentation includes detailed guides, code examples, and API reference materials.
        </p>
        <div className="mb-4 mt-3 flex flex-wrap gap-3">
          <Button asChild>
            <a href={integrationContactHref} className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Contact for Integration Support and API Key
            </a>
          </Button>
          <Button asChild variant="outline">
            <RouterLink to="/api-reference" className="flex items-center gap-2">
            <Code className="h-4 w-4" />
            API Reference
            </RouterLink>
          </Button>
        </div>

        <h2 className="pt-4 text-xl font-semibold">Getting Started</h2>
        <p className="text-muted-foreground">To begin integrating mySign.az with your system, you'll need:</p>
        <ul className="list-inside list-disc space-y-1 text-muted-foreground">
          <li>API credentials (contact us to obtain your API key)</li>
          <li>Access to our integration documentation</li>
          <li>Technical knowledge of RESTful APIs</li>
        </ul>
        <p className="pt-2 text-muted-foreground">
          For assistance with integration or to request API access, please{" "}
          <a href={integrationContactHref} className="text-primary hover:underline">
            contact our support team
          </a>
          .
        </p>
    </section>
  );
}

